const Carousel = (selector, options = {}, cb) => {
    const elements = document.querySelectorAll(selector);

    if (elements.length) {
        import(
            /* webpackChunkName: "carousel" */
            "./carousel"
        ).then(({ default: CarouselInstance }) => {
            elements.forEach((element) => {
                const inst = new CarouselInstance(element, options);
                if (typeof cb === "function") {
                    cb(inst);
                }
            });
        });
    }
};

export default Carousel;
